export function getParents( elem ) {
	const matched: HTMLElement[] = [];

	while ( ( elem = elem.parentNode ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			matched.push( elem );
		}
	}
	return matched;
}

export function isTouchSupported() {
    // 添加 SSR 安全检查
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
        return false;
    }

    return ('ontouchstart' in window) ||
           (navigator.maxTouchPoints > 0) ||
           (navigator['msMaxTouchPoints'] > 0);
}